module.exports = __webpack_public_path__ + "img/close-light.a39d44c7.svg";